import { mailRequest, sendPath, sendPayload } from '../mailboxModel';

export const fetchProfile = () => mailRequest('/me');
export const fetchLabels = () => mailRequest('/labels');
export const fetchThreads = params => mailRequest('/threads', { params });
export async function fetchDraftsWithDetails(params) {
  const data = await mailRequest('/drafts', { params });
  const drafts = await Promise.all(data.drafts.map(async row => { const result = await mailRequest(`/drafts/${encodeURIComponent(row.id)}`); return { ...row, latest_message: result.message, message_count: 1, draft: result }; }));
  return { ...data, drafts };
}
export const fetchThread = id => mailRequest(`/threads/${encodeURIComponent(id)}`);
export const threadAction = (id, action, extra = {}) => mailRequest(`/threads/${encodeURIComponent(id)}/actions`, { method: 'post', data: { action, ...extra } });
export const syncMailbox = () => mailRequest('/sync', { method: 'post' });
export const fetchOutboundCommands = status => mailRequest('/outbound-commands', { params: { status } });
export const reconcileOutbound = () => mailRequest('/outbound-commands/reconcile', { method: 'post' });
export const deleteGmailDraft = id => mailRequest(`/drafts/${id}`, { method: 'delete' });
export const downloadAttachment = (messageId, attachmentId, options = {}) => mailRequest(`/messages/${encodeURIComponent(messageId)}/attachments/${encodeURIComponent(attachmentId)}`, { responseType: 'blob', ...options });
export const fetchNotifications = () => mailRequest('/notifications', { params: { unacknowledged_only: true, limit: 50 } });
export const acknowledgeNotification = id => mailRequest(`/notifications/${id}/acknowledge`, { method: 'post' });
export const fetchSignature = () => mailRequest('/settings/signature');

export const sendDraft = (draft, key) => mailRequest(sendPath(draft), { method: 'post', data: sendPayload(draft, key) });
